import React from 'react'
export default function HomePage() {
  return (
    <div className='flex items-center justify-center'>
        <h1 className='text-center xl:text-9xl' >Inicio</h1>
    </div>
  )
}
